angular
  .module("app.containers")

  .component("pageContainer", {
    transclude: true,
    bindings: {
      //Shown process title is a convetion: propMap[processName + '_' + processIndex]
      processName: "@",
      processIndex: "@",
      progressBar: '<',
      openModal: '&',
      actionBar: '<'
    },
    templateUrl: "ng/containers/pageContainer/pageContainer.view.html",
    controllerAs: "pageContainerCtrl",
    controller: PageContainerController
  });

function PageContainerController($rootScope) {
  var self = this;

  self.$onInit = function () {
    self.getIndex();
    //albaInit();
    self.processIndexGroup();
    console.log(self.progressBar);
    self.actionBar = self.actionBar;
  };

  self.$onChanges = function (change) {

    if (change.progressBar && change.progressBar.currentValue) {
      console.log(self.progressBar);
    }
  }

  self.getIndex = function () {
    var index = parseInt(self.processIndex) - 5;
    if (index > 0) {
      return index;
    } else {
      return 0;
    }
  };

  self.processIndexGroup = function () {
    var index = parseInt(self.processIndex);

    if ($rootScope.wizardMap && $rootScope.wizardMap.find(function (element) { return element.index == index })) {
      return $rootScope.wizardMap
        .find(function (element) {
          return element.index == index
        }).viewName
    }
  }

  self.callOpenModal = function () {
    self.openModal();
  }
}